export var TextState;
(function (TextState) {
    TextState["Default"] = "";
    TextState["Active"] = "active";
    TextState["Disabled"] = "disabled";
})(TextState || (TextState = {}));
